<app-alert [classes]="'alert-full'" [type]="alert?.type" (close)="closeClick()" [value]="alert?.value">
</app-alert>
